import { Crop } from 'react-image-crop';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Size } from '../../typings/common';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

import { closeModal, CreativeSmartCenterModalAction, cropComplete, saveModal, setImageSize } from './actions';
import { CreativeSmartCenterModal, CreativeSmartCenterModalProps } from './CreativeSmartCenterModal';

export type StateProps = TStateProps<CreativeSmartCenterModalProps>;

export type DispatchProps = TDispatchProps<CreativeSmartCenterModalProps>;

interface OwnProps {
    onClose: () => void;
}

export const mapStateToProps = (state: State): StateProps => {
    const { cropData, imageData, isVisible, isLoading, error } = state.canvasEditor.canvas.creativeSmartCenterModal;

    return {
        isVisible,
        isLoading,
        error,
        src: imageData ? imageData.src : undefined,
        crop: cropData ? cropData.crop : undefined
    };
};

const mapDispatchToProps = (dispatch: Dispatch<CreativeSmartCenterModalAction>, ownProps: OwnProps): DispatchProps => {
    return {
        onClose: (): void => {
            dispatch(closeModal());

            ownProps.onClose();
        },
        onSave: (image: HTMLImageElement): void => {
            dispatch(saveModal(image));
        },
        onCropComplete: (crop: Crop): void => {
            dispatch(cropComplete(crop));
        },
        onImageLoaded: (naturalImageSize: Size, imageSize: Size): void => {
            dispatch(setImageSize(naturalImageSize, imageSize));
        }
    };
};

export const CreativeSmartCenterModalContainer = connect<StateProps, DispatchProps, OwnProps>(
    mapStateToProps,
    mapDispatchToProps
)(CreativeSmartCenterModal);
